import { Box, styled, Theme } from "@mui/material";

const baseAdminContainerStyles = (theme: Theme) => ({
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.surfaceLight10.main,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.surfaceLight40.main}`,
  padding: "28px",
});

const BaseAdminContainer = styled(Box)(({ theme }) => ({
  ...baseAdminContainerStyles(theme),
}));

const DrawerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "80vw",
  height: "100%",
  backgroundColor: theme.palette.surfaceLight20.main,
  padding: "24px",
}));

const Spacer = styled("div")`
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
`;

const InlineBlock = styled("div")`
  display: inline-block;
`;

const SpanHoverLink = styled("span")(({ theme }) => ({
  textDecoration: "none",
  padding: "5px",
  color: theme.palette.accentInfo30.main,
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

const AnchorHoverLink = styled("a")(({ theme }) => ({
  textDecoration: "none",
  padding: "5px",
  color: theme.palette.accentInfo30.main,
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

const HiddenDiv = styled("div")`
  visibility: hidden;
`;

const PageContainer = styled("div")`
  position: relative;
  padding: 12px 0px 15px 0px;
  margin-bottom: 20px;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
`;

const ScrollablePageContainer = styled(PageContainer)`
  overflow-x: auto;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  padding: 0;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }
`;

export {
  AnchorHoverLink,
  BaseAdminContainer,
  baseAdminContainerStyles,
  DrawerContainer,
  HiddenDiv,
  InlineBlock,
  PageContainer,
  ScrollablePageContainer,
  Spacer,
  SpanHoverLink,
};
